import { useMemo } from 'react';
import { makeBEM, makeRootClassName } from '../../../utils';
export var useButtonClassName = function useButtonClassName(classPrefix, className, disabled, small, wide, primary, secondary, tertiary, danger) {
  return useMemo(function () {
    var baseClassNames = makeRootClassName(classPrefix, className);
    var stateClassNames = [];

    if (disabled) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'disabled'));
    }

    if (small) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'small'));
    }

    if (wide) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'wide'));
    }

    if (primary && !secondary && !tertiary) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'primary'));
    }

    if (secondary) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'secondary'));
    }

    if (tertiary) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'tertiary'));
    }

    if (danger) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'danger'));
    }

    return "".concat(baseClassNames, " ").concat(stateClassNames.join(' ')).trim();
  }, [classPrefix, className, disabled, small, wide, primary, secondary, tertiary, danger]);
};